module.exports = __webpack_public_path__ + "img/silver3.a2db71f8.png";